import { Component } from 'react'
import { connect } from 'react-redux'

class ACL extends Component {
	// Checks the given 'permission' (prop) against the current users permissions
	// list and renders the children only if the permission is present.

	getUserPermissions() {
		const { user } = this.props.userHandler;
		return user ? user.permissions : [];
	}

	allowPermission() {
		const { allow } = this.props;
		if (!allow) return true;

		const assigned = this.getUserPermissions();
		const allowed = typeof allow === 'string' ? new Array(allow)
			: Array.isArray(allow) ? allow : [];

		return allowed.filter(permission => assigned.includes(permission)).length > 0;
	}

	disallowPermission() {
		const { disallow } = this.props;
		if (!disallow) return true;

		const assigned = this.getUserPermissions();
		const disallowed = typeof disallow === 'string' ? new Array(disallow)
			: Array.isArray(disallow) ? disallow : [];

		return disallowed.filter(permission => assigned.includes(permission)).length === 0;
	}

	render() {
		if (this.props.allow) {
			return this.allowPermission() && this.props.children;
		}
		else if (this.props.disallow) {
			return this.disallowPermission() && this.props.children;
		}
		else return this.props.children;
	}
}

const mapStateToProps = (state) => {
	return { userHandler: state.userHandler }
};

export default connect(mapStateToProps)(ACL);


// WEBPACK FOOTER //
// ./src/components/common/ACL.jsx